import React from 'react';

var alignmentClass = function (classPrefix, alignment) {
    if (!alignment) {
        return undefined;
    }
    return classPrefix + 'align-' + alignment;
};
var concatClasses = function (classes) { return classes.filter(Boolean).join(' '); };
var cmsImageUrl = function (path, mediaServerUrl) { return mediaServerUrl + '/magazine-pictures/' + path; };
var imgUrl = function (imgSource, mediaServerUrl) {
    switch (imgSource.type) {
        case 'external':
            return imgSource.url;
        case 'cms':
            if (!imgSource.path) {
                return undefined;
            }
            return cmsImageUrl(imgSource.path, mediaServerUrl);
        case 'product':
            if (!imgSource.coverUrlPath) {
                return undefined;
            }
            return mediaServerUrl + '/shop/coverscans/' + imgSource.coverUrlPath;
    }
};
var priceString = function (price) {
    if (price === undefined) {
        return '';
    }
    // \u00A0 is the non breaking space
    return (price / 100).toFixed(2).replace('.', ',') + '\u00A0€';
};
var linkHref = function (linkData, mediaServerUrl, anchor) {
    var href = '';
    switch (linkData.type) {
        case 'nav':
            href = '/de/category/' + linkData.naviId + '/' + (linkData.linkText || '') + '.html';
            break;
        case 'product':
            // product links are not implemented yet, they are different between clients
            return '#';
        case 'extern':
            return linkData.url;
        case 'mail':
            return 'mailto:' + linkData.recipient;
        case 'bestseller':
            href = '/de/category/bestseller/' + linkData.naviId;
            break;
        case 'cms':
            href = cmsImageUrl(linkData.imageUrl, mediaServerUrl);
            break;
        default:
            return '#';
    }
    return anchor ? href + '#' + anchor : href;
};
var Util = { alignmentClass: alignmentClass, concatClasses: concatClasses, imgUrl: imgUrl, priceString: priceString, linkHref: linkHref };

var Text = function (_a) {
    var content = _a.node.content;
    return React.createElement(React.Fragment, null, content);
};
var Break = function (_a) {
    var classPrefix = _a.classPrefix;
    return React.createElement("br", { className: classPrefix + 'break' });
};
var Linebreak = function (_a) {
    var classPrefix = _a.classPrefix;
    return React.createElement("br", { className: classPrefix + 'linebreak' });
};
var Pagebreak = function (_a) {
    var classPrefix = _a.classPrefix;
    return React.createElement("br", { className: classPrefix + 'pagebreak' });
};
var Separator = function (_a) {
    var classPrefix = _a.classPrefix;
    return React.createElement("div", { className: classPrefix + 'separator' });
};
var PriceLabel = function (_a) {
    var price = _a.node.price, classPrefix = _a.classPrefix;
    return React.createElement("div", { className: classPrefix + 'price' }, Util.priceString(price));
};
var OrderButton = function (_a) {
    var classPrefix = _a.classPrefix;
    return (
    // the order button is not implemented yet
    React.createElement("div", { className: classPrefix + 'add-to-cart-button' }));
};
/* the order button is not implemented yet, so just show the price*/
var PriceLabelWithOrderButton = function (_a) {
    var price = _a.node.price, classPrefix = _a.classPrefix;
    return React.createElement("div", { className: classPrefix + 'price' }, Util.priceString(price));
};
var Rating = function (_a) {
    var ratingAverage = _a.node.ratingAverage, classPrefix = _a.classPrefix;
    if (ratingAverage === undefined) {
        return React.createElement(React.Fragment, null);
    }
    var rating = ratingAverage / 20.0;
    var starClass = classPrefix + 'star';
    var fullStarClasses = Util.concatClasses([starClass, classPrefix + 'star-full']);
    var halfStarClasses = Util.concatClasses([starClass, classPrefix + 'star-half']);
    var emptyStarClasses = Util.concatClasses([starClass, classPrefix + 'star-empty']);
    return (React.createElement("div", { className: classPrefix + 'rating' }, [0, 1, 2, 3, 4].map(function (i) {
        if (Math.floor(rating) > i) {
            return React.createElement("span", { className: fullStarClasses, key: i });
        }
        else if (rating > i) {
            return React.createElement("span", { className: halfStarClasses, key: i });
        }
        else {
            return React.createElement("span", { className: emptyStarClasses, key: i });
        }
    })));
};
var Unknown = function (_a) {
    var classPrefix = _a.classPrefix;
    return React.createElement("span", { className: classPrefix + 'unknown' });
};

var Image = function (_a) {
    var _b = _a.node, alignment = _b.alignment, source = _b.source, height = _b.height, width = _b.width, mediaServerUrl = _a.mediaServerUrl, classPrefix = _a.classPrefix;
    var rawClasses = ['wiki-image', Util.alignmentClass(classPrefix, alignment)];
    var classes = Util.concatClasses(rawClasses);
    var imgUrl = Util.imgUrl(source, mediaServerUrl);
    return (React.createElement("img", { className: classes, src: imgUrl, width: (width || 0) > 0 ? width : undefined, height: (height || 0) > 0 ? height : undefined, 
        // the alt attribute is mandatory, but we have no meaningful value for the alt attribute here
        alt: "" }));
};

/**
 * Render parsed wikitext
 * @param node the root not of the wikitext to be parsed
 * @param mediaServerUrl the media server base URL (required mostly for images)
 * @param classPrefix a string that will precede all wikitext element classes to give the caller
 * an option ti make the html classes of the wikitext unique for the project
 *
 * IMPORTANT: some functionality is not implemented yet. Not all Wikitext elements are functional:
 * - links to article details pages (in the image and the link node) will not work. There are two ways to render
 *   an article link, dependend on the client (hugendubel or ebook.de). To implement article links, this information is required
 * - the order button (and the order button with price label) do nothing yet.
 *   To change this, a callback to the cart is required.
 */
var WikiText = function (_a) {
    var node = _a.node, mediaServerUrl = _a.mediaServerUrl, classPrefix = _a.classPrefix;
    switch (node.type) {
        case 'tree':
            return React.createElement(Tree, { node: node, mediaServerUrl: mediaServerUrl, classPrefix: classPrefix });
        case 'text':
            return React.createElement(Text, { node: node });
        case 'orientation':
            return React.createElement(Orientation, { node: node, mediaServerUrl: mediaServerUrl, classPrefix: classPrefix });
        case 'bold':
            return React.createElement(Bold, { node: node, mediaServerUrl: mediaServerUrl, classPrefix: classPrefix });
        case 'italic':
            return React.createElement(Italic, { node: node, mediaServerUrl: mediaServerUrl, classPrefix: classPrefix });
        case 'underline':
            return React.createElement(Underline, { node: node, mediaServerUrl: mediaServerUrl, classPrefix: classPrefix });
        case 'footnote':
            return React.createElement(Footnote, { node: node, mediaServerUrl: mediaServerUrl, classPrefix: classPrefix });
        case 'image':
            return React.createElement(Image, { node: node, mediaServerUrl: mediaServerUrl, classPrefix: classPrefix });
        case 'headline1':
            return React.createElement(Headline1, { node: node, mediaServerUrl: mediaServerUrl, classPrefix: classPrefix });
        case 'headline2':
            return React.createElement(Headline2, { node: node, mediaServerUrl: mediaServerUrl, classPrefix: classPrefix });
        case 'headline3':
            return React.createElement(Headline3, { node: node, mediaServerUrl: mediaServerUrl, classPrefix: classPrefix });
        case 'headline4':
            return React.createElement(Headline4, { node: node, mediaServerUrl: mediaServerUrl, classPrefix: classPrefix });
        case 'headline5':
            return React.createElement(Headline5, { node: node, mediaServerUrl: mediaServerUrl, classPrefix: classPrefix });
        case 'headline6':
            return React.createElement(Headline6, { node: node, mediaServerUrl: mediaServerUrl, classPrefix: classPrefix });
        case 'break':
            return React.createElement(Break, { classPrefix: classPrefix });
        case 'linebreak':
            return React.createElement(Linebreak, { classPrefix: classPrefix });
        case 'pagebreak':
            return React.createElement(Pagebreak, { classPrefix: classPrefix });
        case 'trenner':
            return React.createElement(Separator, { classPrefix: classPrefix });
        case 'price-label':
            return React.createElement(PriceLabel, { node: node, classPrefix: classPrefix });
        case 'order-button':
            return React.createElement(OrderButton, { classPrefix: classPrefix });
        case 'price-label-with-order-button':
            return React.createElement(PriceLabelWithOrderButton, { node: node, classPrefix: classPrefix });
        case 'rating':
            return React.createElement(Rating, { node: node, classPrefix: classPrefix });
        case 'link':
            return React.createElement(Link, { node: node, mediaServerUrl: mediaServerUrl, classPrefix: classPrefix });
        default:
            return React.createElement(Unknown, { classPrefix: classPrefix });
    }
};
var renderChildren = function (children, mediaServerUrl, classPrefix) {
    return children.map(function (child, index) { return (React.createElement(WikiText, { key: index, node: child, mediaServerUrl: mediaServerUrl, classPrefix: classPrefix })); });
};
var Tree = function (_a) {
    var children = _a.node.children, mediaServerUrl = _a.mediaServerUrl, classPrefix = _a.classPrefix;
    return (React.createElement("div", { className: classPrefix + 'tree' }, renderChildren(children, mediaServerUrl, classPrefix)));
};
var Orientation = function (_a) {
    var _b = _a.node, alignment = _b.alignment, children = _b.children, mediaServerUrl = _a.mediaServerUrl, classPrefix = _a.classPrefix;
    return (React.createElement("div", { className: Util.alignmentClass(classPrefix, alignment) }, renderChildren(children, mediaServerUrl, classPrefix)));
};
var Bold = function (_a) {
    var children = _a.node.children, mediaServerUrl = _a.mediaServerUrl, classPrefix = _a.classPrefix;
    return (React.createElement("span", { className: classPrefix + 'bold' }, renderChildren(children, mediaServerUrl, classPrefix)));
};
var Italic = function (_a) {
    var children = _a.node.children, mediaServerUrl = _a.mediaServerUrl, classPrefix = _a.classPrefix;
    return (React.createElement("span", { className: classPrefix + 'italic' }, renderChildren(children, mediaServerUrl, classPrefix)));
};
var Underline = function (_a) {
    var children = _a.node.children, mediaServerUrl = _a.mediaServerUrl, classPrefix = _a.classPrefix;
    return React.createElement("span", { className: classPrefix + 'underline' }, renderChildren(children, mediaServerUrl, classPrefix));
};
var Footnote = function (_a) {
    var children = _a.node.children, mediaServerUrl = _a.mediaServerUrl, classPrefix = _a.classPrefix;
    return React.createElement("span", { className: classPrefix + 'footnote-ref' }, renderChildren(children, mediaServerUrl, classPrefix));
};
var Headline1 = function (_a) {
    var children = _a.node.children, mediaServerUrl = _a.mediaServerUrl, classPrefix = _a.classPrefix;
    return (
    // headlines are shifted by 1. Reason: There should be only one h1 per page (for SEO reasons mostly). Historically,
    // many, many textblocks have been created with headline 1 wikitext. As always with this wikitext, semantical
    // misuse was to expensive to fix so we had to change the semantics of the wikitext instead.
    React.createElement("h2", { className: classPrefix + 'headline1' }, renderChildren(children, mediaServerUrl, classPrefix)));
};
var Headline2 = function (_a) {
    var children = _a.node.children, mediaServerUrl = _a.mediaServerUrl, classPrefix = _a.classPrefix;
    return (
    // headlines are shifted by 1. Reason: see comment in Headline1
    React.createElement("h3", { className: classPrefix + 'headline2' }, renderChildren(children, mediaServerUrl, classPrefix)));
};
var Headline3 = function (_a) {
    var children = _a.node.children, mediaServerUrl = _a.mediaServerUrl, classPrefix = _a.classPrefix;
    return (
    // headlines >= 3 are rendered as div. Reason: the content team used them as list elements for layout reasons
    // This is bad for SEO reasons, because it is in contrast to the semantic meaning of headlines.
    // since it would be too much work to correct the content that is already in use we now render them as div
    // (I almost cried when we had to do this)
    React.createElement("div", { className: classPrefix + 'headline3' }, renderChildren(children, mediaServerUrl, classPrefix)));
};
var Headline4 = function (_a) {
    var children = _a.node.children, mediaServerUrl = _a.mediaServerUrl, classPrefix = _a.classPrefix;
    return (
    // headlines >= 3 are rendered as div. Reason: see Headline3
    React.createElement("div", { className: classPrefix + 'headline4' }, renderChildren(children, mediaServerUrl, classPrefix)));
};
var Headline5 = function (_a) {
    var children = _a.node.children, mediaServerUrl = _a.mediaServerUrl, classPrefix = _a.classPrefix;
    return (
    // headlines >= 3 are rendered as div. Reason: see Headline3
    React.createElement("div", { className: classPrefix + 'headline5' }, renderChildren(children, mediaServerUrl, classPrefix)));
};
var Headline6 = function (_a) {
    var children = _a.node.children, mediaServerUrl = _a.mediaServerUrl, classPrefix = _a.classPrefix;
    return (
    // headlines >= 3 are rendered as div. Reason: see Headline3
    React.createElement("div", { className: classPrefix + 'headline6' }, renderChildren(children, mediaServerUrl, classPrefix)));
};
var Link = function (_a) {
    var _b = _a.node, linkData = _b.linkData, anchor = _b.anchor, rel = _b.rel, rawTarget = _b.target, label = _b.label, mediaServerUrl = _a.mediaServerUrl, classPrefix = _a.classPrefix;
    // the '_lightbox' target is a dummy target that is used to open the target in an overlay in the bookshop
    // we can just assume it is a _blank target here
    var target = rawTarget === '_lightbox' ? '_blank' : rawTarget;
    var href = Util.linkHref(linkData, mediaServerUrl, anchor);
    var labelElement = label ? (React.createElement(WikiText, { node: label, mediaServerUrl: mediaServerUrl, classPrefix: classPrefix })) : ('link');
    return (React.createElement("a", { href: href, target: target, rel: rel, className: classPrefix + 'link' }, labelElement));
};

export { WikiText };
